import { useCallback, useEffect, useState } from "react";
import useHttp from "hooks/use-http";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import ContactCM from "components/contactus";
import { Link } from "react-router-dom";
import {
  StyledCardContent,
  StyledCard,
  StyledTypography,
  StyledCardActions,
  StyledContainer,
  StyledTypographydetail,
  StyledCardContentTop,
  StyledButton,
  StyledCardcolleague,
} from "./Address.style";
import { getUserInfoRequest, getUserAddressRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import { PAGINATION_LIMIT_10 } from "constants";
import { FiMail } from "react-icons/fi";
import { ImEarth } from "react-icons/im";
import { GoLocation } from "react-icons/go";
import { AiOutlineEdit } from "react-icons/ai";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import Button from "@mui/material/Button";
import {Helmet} from "react-helmet";

export default function Address() {
  const { request, loading } = useHttp();
  const [user, setUser] = useState(0);
  const [address, setAddress] = useState({ data: [], count: 0 });
  const [page, setPage] = useState(1);

  const getUserInfo = useCallback(async () => {
    const res = await request({
      url: getUserInfoRequest,
    });
    if (res) {
      setUser(res);
    }
  }, [request]);

  const getAddress = useCallback(async () => {
    const res = await request({
      url: getUserAddressRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT_10,
        limit: PAGINATION_LIMIT_10,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      address: items?.address,
      state: items?.state,
      city: items?.city,
      postal_code: items?.postal_code,
    }));

    setAddress({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getUserInfo();
    getAddress();
  }, [page, getAddress]);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>آدرس های من - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="آدرس های من" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  آدرس های من
                </Typography>
              </StyledCardContent>
              <CardContent>
                {user.type == "user" ? (
                  <div style={{ textAlign: "left" }}>
                    <Link to={`/address/add`}>
                      <Button variant="outlined" style={{ marginLeft: "20px" }}>
                        <AddLocationIcon />{" "}
                        <span style={{ marginRight: "10px" }}>
                          ثبت آدرس جدید
                        </span>
                      </Button>
                    </Link>
                  </div>
                ) : (
                  ""
                )}
                {address.count < 1 ? (
                  <div style={{ textAlign: "center", padding: "28px" }}>
                    آدرسی یافت نشد
                  </div>
                ) : (
                  <>
                    {user.type == "user" ? (
                      <StyledContainer pb={2} spacing={2} mt={2}>
                        {address.data.map((items, index) => (
                          <StyledCard key={"card" + index}>
                            <StyledCardContentTop>
                              <StyledTypography variant="body2">
                                {items.address}
                              </StyledTypography>
                              <StyledTypographydetail variant="body2">
                                <ImEarth /> <span>{items.state}</span>
                              </StyledTypographydetail>
                              <StyledTypographydetail variant="body2">
                                <GoLocation /> <span>{items.city}</span>
                              </StyledTypographydetail>
                              <StyledTypographydetail variant="body2">
                                <FiMail /> <span>{items.postal_code}</span>
                              </StyledTypographydetail>
                            </StyledCardContentTop>
                            <StyledCardActions style={{ direction: "ltr" }}>
                              <Link
                                to={`/address/${items.id}`}
                                key={"list" + index}
                              >
                                <StyledButton size="small">
                                  <AiOutlineEdit size="20" />
                                  <span>ویرایش آدرس</span>
                                </StyledButton>
                              </Link>
                            </StyledCardActions>
                          </StyledCard>
                        ))}
                        <Grid container my={2} spacing={1}>
                          <Grid item xs={12}>
                            <PaginationCM
                              handleChange={(e, val) => setPage(val)}
                              page={page}
                              limit={PAGINATION_LIMIT_10}
                              count={address.count}
                            />
                          </Grid>
                        </Grid>
                      </StyledContainer>
                    ) : (
                      ""
                    )}

                    {user.type == "colleague" ? (
                      <StyledContainer pb={2} spacing={2} mt={2}>
                        {address.data.map((items, index) => (
                          <StyledCardcolleague key={"card" + index}>
                            <StyledCardContentTop>
                              <StyledTypography variant="body2">
                                {items.address}
                              </StyledTypography>
                              <StyledTypographydetail variant="body2">
                                <ImEarth /> <span>{items.state}</span>
                              </StyledTypographydetail>
                              <StyledTypographydetail variant="body2">
                                <GoLocation /> <span>{items.city}</span>
                              </StyledTypographydetail>
                              <StyledTypographydetail variant="body2">
                                <FiMail /> <span>{items.postal_code}</span>
                              </StyledTypographydetail>
                            </StyledCardContentTop>
                          </StyledCardcolleague>
                        ))}
                      </StyledContainer>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
